module.exports = __webpack_public_path__ + "img/263.clean_garbage.c6d2ee5e.svg";